import $ from 'jquery';
import * as bootstrap from 'bootstrap'

$('.logo-carousel').slick({
    dots: false,
    infinite: true,
    arrows: true,
    nextArrow: $('.the-next-slide'),
    prevArrow: $('.the-previous-slide'),
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 2,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.mobile-carousel').slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    mobileFirst: true,
    responsive: [
          {
                  breakpoint: 768,
                  settings: 'unslick'
          }
    ]
  });


  //bootstrap carousels
  
  //to make bootstrap carousel controls (located in section.php) work without 
  //HTML IDs I am firing the next and prev methods on the carousel object manually here.

  var theCarousels = $('.boot-carousel');

  theCarousels.each(function( index ) {

    var carouselObj = new bootstrap.Carousel(this);

    $('.carousel-control-prev').on('click', function() {
        carouselObj.prev();
    });

    $('.carousel-control-next').on('click', function() {
      carouselObj.next();
    });

  });

